import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { Formik } from 'formik';
import 'formik';
import { Icon } from 'Components/frameworks/icon/Icon';
import { FormikInput } from 'Components/frameworks/formik/FormikInput';
export const RadioButtonWithIcon = ({
  icon,
  isChecked,
  title,
  description,
  value,
  name,
  priceDifference,
  testId = 'RadioButtonWithIcon',
}: {
  icon: IconName;
  title: string;
  description: string;
  name: string;
  priceDifference?: string;
  value: string;
  testId?: string;
  isChecked: Formik;
}) => {
  return (
    <div
      className={classnames(
        'flex h-full flex-col overflow-hidden rounded-12 border-1 p-15 text-center leading-normal',
        {
          'border-lightGrey': !isChecked,
          'border-saffron': isChecked,
        },
      )}
      data-testid={testId}
    >
      <Icon
        className="m-auto mb-10"
        dataTestid="RadioButtonWithIcon-icon"
        name={icon}
        width="2em"
      />
      <div className="w-full text-12 font-bold leading-tight">{title}</div>
      <div className="w-full text-10 leading-tight text-black">{description}</div>
      <div className="m-auto">
        <FormikInput className="ml-10" name={name} value={value} type="radio" />
      </div>
      {!!priceDifference && (
        <div className="w-full text-12 font-bold leading-tight">{priceDifference}</div>
      )}
    </div>
  );
};
